// Area Navigation component

import {
  type AreaNavigationProps,
  NavigationItem,
} from '@backoffice-frontend/patterns'
import { MessageIcon } from '@moia-dev/pace-icons'
import { RiderFeedbackAreaRoutes } from './RiderFeedbackAreaRoutes'

export const RiderFeedbackAreaNavigationIcon = MessageIcon

export const RiderFeedbackAreaNavigation = ({
  onClick,
  open,
  label,
}: AreaNavigationProps) => {
  return (
    <NavigationItem
      onClick={onClick}
      open={open}
      label={label}
      to={RiderFeedbackAreaRoutes.route}
      Icon={MessageIcon}
    />
  )
}
